import { render } from "./ListDataIzinAll.vue?vue&type=template&id=6c831ffa"
import script from "./ListDataIzinAll.vue?vue&type=script&lang=js"
export * from "./ListDataIzinAll.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__